import { Loader2, FileSearch } from "lucide-react";
import { useAppSelector } from "@/hooks/use-state";
import { selectAuthLoading, selectUser } from "@/features/auth/authSlice";
import { Card, CardContent, CardDescription, CardHeader,  CardTitle } from "@/components/ui/card";


export default function MyAccountPage() {
  const isLoadingAuth = useAppSelector(selectAuthLoading);
  const user = useAppSelector(selectUser);
  // Verificar si se están cargando los datos
  const isLoading = isLoadingAuth;

  return (
    <Card className="min-h-96">
      <CardHeader className="py-4 px-6">
        <CardTitle className="text-2xl pt-0">{'Mi Cuenta - ' + user?.name}</CardTitle>
        <CardDescription></CardDescription>
      </CardHeader>
      <CardContent>
        { isLoading ? (
          <div className="flex justify-center p-12">
            <Loader2 className="h-8 w-8 animate-spin text-primary" />
          </div>
        ):(
          <div className="flex flex-col justify-center items-center p-12">
            <FileSearch className="h-16 w-16 mr-2 text-gray-300 p-2" />
            Módulo de Mi Cuenta - Proximamente.
          </div>
        )}
      </CardContent>
    </Card>
  );
}